/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from "react";
import API from "../../../utils/API";
import PropTypes from "prop-types";
import tableStyle from "../../../assets/jss/material-dashboard-react/components/tableStyle";
import { Grid, Typography, Tab, Tabs, Box, CircularProgress } from "@mui/material";
import PSelect from "../../../components/pos/PSelect";
import PText from "../../../components/pos/PText";
import PDialog from "../../../components/pos/PDialog";
import { SyncUtils } from "../../../utils/SyncUtils";
import PConfirm from "../../../components/pos/PConfirm";
import { useTranslation } from "react-i18next";

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function AccountingsettingsCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState(
    translate("New Accounting Settings")
  );
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);
  const [value, setValue] = useState(0);
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState("");
  const [ledger, setLedger] = useState("");
  const [ledgerError, setLedgerError] = useState("");
  const [ledgerOptions, setLedgerOptions] = useState([]);
  const [openingBalance, setOpeningBalance] = useState(0);
  const [openingBalanceError, setOpeningBalanceError] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState("");

  const [ledgerFlag, setLedgerFlag] = useState(false);
  const [subLedgerFlag, setSubLedgerFlag] = useState(false);
  const [parentId, setParentId] = useState("");
  const [level, setLevel] = useState(0);
  const [balance, setBalance] = useState(0);

  const [nature, setNature] = useState(0);
  const [openingNature, setOpeningNature] = useState("");
  const [openingNatureError, setOpeningNatureError] = useState("");
  const [openingNatureOptions, setOpeningNatureOptions] = useState([]);

  const [type, setType] = useState("");
  const [typeError, setTypeError] = useState("");
  const [typeOptions, setTypeOptions] = useState([]);
  const [accountNumber, setAccountnumber] = useState("");
  const [accountNumberError, setAccountnumberError] = useState("");
  const [bankName, setBankname] = useState("");
  const [bankNameError, setBanknameError] = useState("");

  const [enableMoreDetails, setEnableMoreDetails] = useState(false);
  const [branchName, setBranchname] = useState("");
  const [branchNameError, setBranchnameError] = useState("");
  const [iBanNumber, setIbannumber] = useState("");
  const [iBanNumberError, setIbannumberError] = useState("");
  const [currency, setCurrency] = useState("");
  const [currencyError, setCurrencyError] = useState("");
  const [accountStatus, setAccountstatus] = useState("");
  const [accountStatusError, setAccountstatusError] = useState("");
  const [accountStatusOptions, setAccountstatusOptions] = useState([]);
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.child = {
    showAccountingsettingsCrudWindow: showAccountingsettingsCrudWindow,
  };

  useEffect(() => {
    setOpeningNatureOptions([
      { name: "CREDIT", value: "CREDIT" },
      { name: "DEBIT", value: "DEBIT" },
    ]);
  }, []);

  useEffect(() => {
    if (liveValidation && name === "")
      setNameError(translate("Name is Required"));
    else setNameError("");
  }, [name]);
  useEffect(() => {
    if (liveValidation && openingNature.value === "")
      setNameError(translate("Select Account Opening Nature"));
    else setNameError("");
  }, [name]);
  useEffect(() => {
    if (liveValidation && code === "")
      setCodeError(translate("Code is Required"));
    else setCodeError("");
  }, [code]);
  useEffect(() => {
    if (liveValidation && ledger === "")
      setLedgerError(translate("Ledger is Required"));
    else setLedgerError("");
  }, [ledger]);
  useEffect(() => {
    if (liveValidation && openingBalance === "")
      setOpeningBalanceError(translate("OpeningBalance is Required"));
    else setOpeningBalanceError("");
  }, [openingBalance]);
  /*useEffect(() => {
    if (liveValidation && description === "")
      setDescriptionError("Description is Required");
    else setDescriptionError("");
  }, [description]);

  useEffect(() => {
    if (liveValidation && type === "") setTypeError("Type is Required");
    else setTypeError("");
  }, [type]);
  useEffect(() => {
    if (liveValidation && accountNumber === "")
      setAccountnumberError("Accountnumber is Required");
    else setAccountnumberError("");
  }, [accountNumber]);
  useEffect(() => {
    if (liveValidation && ifsc === "") setIfscError("Ifsc is Required");
    else setIfscError("");
  }, [ifsc]);
  useEffect(() => {
    if (liveValidation && bankName === "")
      setBanknameError("Bankname is Required");
    else setBanknameError("");
  }, [bankName]);*/
  /* useEffect(() => {
    if (liveValidation && branchName === "")
      setBranchnameError("Branchname is Required");
    else setBranchnameError("");
  }, [branchName]);
  useEffect(() => {
    if (liveValidation && iBanNumber === "") setIbannumberError("Ibannumber is Required");
    else setIbannumberError("");
  }, [iBanNumber]);
  useEffect(() => {
    if (liveValidation && currency === "") setCurrencyError("Currency is Required");
    else setCurrencyError("");
  }, [currency]);
  useEffect(() => {
    if (liveValidation && accountStatus === "") setAccountstatusError("Accountstatus is Required");
    else setAccountstatusError("");
  }, [accountStatus]);*/
  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function showAccountingsettingsCrudWindow(
    accountingsettingsId,
    code,
    type,
    lvl,
    mode
  ) {
    setMode(mode);
    if (type == "subledger") populateLedgerOptions();
    else if (type != null) {
      setParentId(accountingsettingsId);
      setLevel(lvl + 1);
      if (type === "ledger") {
        setLedgerFlag(true);
      } else if (type === "subledger") {
        setSubLedgerFlag(true);
      } else {
        setLedgerFlag(false);
        setSubLedgerFlag(false);
      }
      if (type == "ledger" && code == "010102") {
        setEnableMoreDetails(true);
        setAccountstatus([
          { name: "Active", value: "Active" },
          { namr: "Blocked", value: "Blocked" },
        ]);
      }

      resetFields();
      setMode("create");
      setLiveValidation(false);
      setOpenWindow(true);
    } else {
      // setMode("edit");
      setMode(mode);
      populateAccountingsettings(accountingsettingsId);
    }
  }

  async function populateLedgerOptions() {
    setLedgerOptions([]);
    let { data } = await API.get("/api/v1/ledgerlist");
    console.log(JSON.stringify(data));
    let dataArray = [];
    data.map((item, key) => dataArray.push({ id: item.id, name: item.name }));
    setLedgerOptions(dataArray);
  }

  async function populateAccountingsettings(id) {
    {
      try {
        let { data } = await API.get("/api/v1/ledger/" + id);
        setOrigObject(data);
        populateData(data);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive Accounting Settings data from server")
        );
      }
    }
  }

  function populateData(bean) {
    setName(bean.name);
    setCode(bean.code);
    if (bean.subLedgerFlag) {
      setLedger({ id: bean.parentLedger.id, name: bean.parentLedger.name });
    }

    setLevel(bean.level);
    setBalance(bean.balance);
    setLedgerFlag(bean.ledgerFlag);
    setSubLedgerFlag(bean.subLedgerFlag);
    setParentId(bean.parentId);
    setOpeningNature({ name: bean.openingNature, value: bean.openingNature });
    setNature(bean.nature);

    setOpeningBalance(bean.openingBalance);
    setDescription(bean.description);
    setType(bean.type ? { id: bean.type, name: bean.type } : null);

    setAccountnumber(bean.accountNumber);
    setBankname(bean.bankName);
    setBranchname(bean.branchName);
    setIbannumber(bean.iBanNumber);
    setCurrency(bean.currency);
    setAccountstatus(
      bean.accountStatus
        ? { id: bean.accountStatus, name: bean.accountStatus }
        : null
    );

    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setName("");
    setNameError("");
    setCode("AUTO");
    setCodeError("");
    setLedger("");
    setLedgerError("");
    setOpeningBalance(0.0);
    setOpeningBalanceError("");
    setDescription("");
    setDescriptionError("");
    setOpeningNature("");
    setOpeningNatureError("");
    setType("");
    setTypeError("");
    setAccountnumber("");
    setAccountnumberError("");
    setBankname("");
    setBanknameError("");
    setBranchname("");
    setBranchnameError("");
    setIbannumber("");
    setIbannumberError("");
    setCurrency("");
    setCurrencyError("");
    setAccountstatus("");
    setAccountstatusError("");
    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Are You Sure"),
      message:
        translate("Are you sure to delete accounting settings") +
        origObject.name +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
      action: "delete",
    });
  }

  async function onYesNoClicked(context, value) {
    let action = context.action;
    setConfirmOpen(false);

    if (value === "yes" && action === "edit") {
      saveData();
    }

    if (value === "yes" && action === "delete") {
      try {
        let result = await API.delete("/api/v1/ledger/" + origObject.id);
        props.showMessage(
          "warning",
          translate("Accounting Settings ") + name + translate(" got Removed")
        );
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage(
          "error",
          translate("Not able to Delete Accounting Settings")
        );
      }
    }
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function saveData() {
    try {
      var payload = createPayload();
      showProgress(true, "Saving");
      let result = await API.post("/api/v1/ledger", payload);
      console.log("TEST PRINT FOMR CRUD");
      props.showMessage("success", translate("Saved Successfully"));
      props.onRefresh();
      setOpenWindow(false);
      showProgress(false, "Saving");
    } catch (err) {
      showProgress(false, "Saving");
      if (err.response && err.response.status === 412) {
        showDetailedError(err.response.data);
      } else {
        props.showMessage(
          "error",
          translate("Not able to Save Accounting Settings")
        );
      }
    }
  }

  async function onSave() {
    if (validate()) {
      if (
        mode === "edit" &&
        props.context.privileges.ledger_opening_balance_update
      ) {
        setConfirmOpen(true);
        setConfirmContext({
          title: translate("Are You Sure"),
          message: translate(
            "Are you sure to edit opening balance, your ledgre calculation may not be correct after the opening balance edit, Please run ledgre reconcilation for fixing"
          ),
          type: "warning",
          open: true,
          yes: true,
          no: true,
          action: "edit",
        });
      } else {
        saveData();
      }
    }
  }

  function showDetailedError(msg) {
    console.log(msg);
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "name") {
        setNameError(obj.message);
      }
      if (obj.field === "openingNature") {
        setOpeningNatureError(obj.message);
      }
      if (obj.field === "code") {
        setCodeError(obj.message);
      }
      if (obj.field === "ledger") {
        setLedgerError(obj.message);
      }
      if (obj.field === "openingBalance") {
        setOpeningBalanceError(obj.message);
      }
      if (obj.field === "description") {
        setDescriptionError(obj.message);
      }
      /* if (obj.field === "type") {
        setTypeError(obj.message);
      }
      if (obj.field === "accountNumber") {
        setAccountnumberError(obj.message);
      }
      if (obj.field === "ifsc") {
        setIfscError(obj.message);
      }
      if (obj.field === "bankName") {
        setBanknameError(obj.message);
      }
      if (obj.field === "branchName") {
        setBranchnameError(obj.message);
      }
      if (obj.field === "iBanNumber") {
        setIbannumberError(obj.message);
      }
      if (obj.field === "currency") {
        setCurrencyError(obj.message);
      }
      if (obj.field === "accountStatus") {
        setAccountstatusError(obj.message);
      }*/
      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }
    props.showMessage("error", msg.message);
  }

  function handleOpeningBalanceChange(e) {
    setOpeningBalance(e.target.value);
    if (Number(e.target.value) == 0) {
      setOpeningNature("");
    }
  }

  function createPayload() {
    let saveObject = Object.create(null);
    saveObject["name"] = name;
    saveObject["code"] = code;
    saveObject["openingBalance"] = openingBalance;
    saveObject["description"] = description;
    saveObject["ledgerFlag"] = ledgerFlag;
    saveObject["subLedgerFlag"] = subLedgerFlag;
    saveObject["editable"] = true;
    saveObject["parentLedger"] = null;
    saveObject["parentId"] = parentId;
    saveObject["level"] = level;
    saveObject["openingNature"] = openingNature.value;

    saveObject["type"] = type ? type.id : null;
    saveObject["accountNumber"] = accountNumber;
    saveObject["bankName"] = bankName;
    saveObject["branchName"] = branchName;
    saveObject["iBanNumber"] = iBanNumber;
    saveObject["currency"] = currency;
    saveObject["active"] = true;
    saveObject["accountStatus"] = accountStatus;
    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/
    if (mode === "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode === "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
    }
    return saveObject;
  }

  function validate() {
    let flag = true;
    if (!name || name === "") {
      setNameError(translate("Name is Required"));
      flag = false;
    }
    if (
      Number(openingBalance) != 0 &&
      (!openingNature || openingNature === undefined)
    ) {
      setOpeningNatureError(translate("Select openingNature of Account"));
      flag = false;
    }
    if (!code || code === "") {
      setCodeError(translate("Code is Required"));
      flag = false;
    }
    if ((!ledger || ledger === "") && subLedgerFlag) {
      setLedgerError(translate("Ledger is Required"));
      flag = false;
    }
    if (Number(openingBalance < 0) && (ledgerFlag || subLedgerFlag)) {
      setOpeningBalanceError(translate("Opening Balance is Required"));
      flag = false;
    }

    /*  if (!type || type === "") {
      setTypeError("Type is Required");
      flag = false;
    }
    if (!accountNumber || accountNumber === "") {
      setAccountnumberError("Accountnumber is Required");
      flag = false;
    }
    if (!ifsc || ifsc === "") {
      setIfscError("Ifsc is Required");
      flag = false;
    }
    if (!bankName || bankName === "") {
      setBanknameError("Bankname is Required");
      flag = false;
    }
   /* if (!branchName || branchName === "") {
      setBranchnameError("Branchname is Required");
      flag = false;
    }
    if (!iBanNumber || iBanNumber === "") {
      setIbannumberError("Ibannumber is Required");
      flag = false;
    }
    if (!currency || currency === "") {
      setCurrencyError("Currency is Required");
      flag = false;
    }
    if (!accountStatus || accountStatus === "") {
      setAccountstatusError("Accountstatus is Required");
      flag = false;
    }*/
    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  const content1 = (
    <Grid container spacing={3} style={{ height: 250 }}>
      <Grid item xs={12} sm={12}>
        <table width="100%">
          <tbody>
            <tr>
              <td>
                <Typography variant="body1">{translate("Code")}</Typography>
              </td>
              <td>
                <PText
                  value={code}
                  error={codeError}
                  onChange={(e) => setCode(e.target.value)}
                  InputProps={{ readOnly: true }}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">{translate("Name")}</Typography>
              </td>
              <td>
                <PText
                  value={name}
                  error={nameError}
                  onChange={(e) => setName(e.target.value)}
                ></PText>
              </td>
            </tr>

            {subLedgerFlag && (
              <tr>
                <td>
                  <Typography variant="body1">{translate("Ledger")}</Typography>
                </td>
                <td>
                  <PSelect
                    options={ledgerOptions}
                    value={ledger}
                    errorMessage={ledgerError}
                    onChange={(event, newValue) => {
                      setLedger(newValue);
                      setParentId(newValue.id);
                    }}
                  ></PSelect>
                </td>
              </tr>
            )}
            {(ledgerFlag || subLedgerFlag) && (
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Opening Balance")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={openingBalance}
                    error={openingBalanceError}
                    onChange={(e) => handleOpeningBalanceChange(e)}
                  ></PText>
                </td>
              </tr>
            )}
            {(ledgerFlag || subLedgerFlag) && (
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Opening Nature")}
                  </Typography>
                </td>
                <td>
                  <PSelect
                    disabled={openingBalance == 0 ? true : false}
                    options={openingNatureOptions}
                    value={openingNature}
                    errorMessage={openingNatureError}
                    onChange={(event, newValue) => {
                      setOpeningNature(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
            )}
            {/* {(ledgerFlag || subLedgerFlag) && mode === "edit" && (
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Balance")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={balance}
                    InputProps={{ readOnly: true }}
                  ></PText>
                </td>
              </tr>
            )} */}
            {/* {(ledgerFlag || subLedgerFlag) && mode === "edit" && (
              <tr>
                <td>
                  <Typography variant="body1">{translate("nature")}</Typography>
                </td>
                <td>
                  <PText value={nature} InputProps={{ readOnly: true }}></PText>
                </td>
              </tr>
            )} */}
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Description")}
                </Typography>
              </td>
              <td>
                <PText
                  multiline={true}
                  rows={2}
                  maxRows={2}
                  value={description}
                  error={descriptionError}
                  onChange={(e) => setDescription(e.target.value)}
                ></PText>
              </td>
            </tr>
            {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
          </tbody>
        </table>
      </Grid>
    </Grid>
  );
  const content2 = (
    <Grid container spacing={3} style={{ height: 210 }}>
      <Grid item xs={12} sm={12}>
        <table width="100%">
          <tbody>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Bank Name")}
                </Typography>
              </td>
              <td>
                <PText
                  value={bankName}
                  error={bankNameError}
                  onChange={(e) => setBankname(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Account Number")}
                </Typography>
              </td>
              <td>
                <PText
                  value={accountNumber}
                  error={accountNumberError}
                  onChange={(e) => setAccountnumber(e.target.value)}
                ></PText>
              </td>
            </tr>

            <tr>
              <td>
                <Typography variant="body1">
                  {translate("Branch Name")}
                </Typography>
              </td>
              <td>
                <PText
                  value={branchName}
                  error={branchNameError}
                  onChange={(e) => setBranchname(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {translate("IBAN/IFSC")}
                </Typography>
              </td>
              <td>
                <PText
                  value={iBanNumber}
                  error={iBanNumberError}
                  onChange={(e) => setIbannumber(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">{translate("Currency")}</Typography>
              </td>
              <td>
                <PText
                  value={currency}
                  error={currencyError}
                  onChange={(e) => setCurrency(e.target.value)}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">{translate("Status")}</Typography>
              </td>
              <td>
                <PSelect
                  options={accountStatusOptions}
                  value={accountStatus}
                  errorMessage={accountStatusError}
                  onChange={(event, newValue) => {
                    setAccountstatus(newValue);
                  }}
                ></PSelect>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
    </Grid>
  );
  const content = (
    <div>
      <Tabs value={value} onChange={handleChange}>
        <Tab label={translate("Basic Details")} />
        {enableMoreDetails && <Tab label={translate("More Details")} />}
      </Tabs>

      <TabPanel value={value} index={0}>
        {content1}
      </TabPanel>
      <TabPanel value={value} index={1}>
        {content2}
      </TabPanel>
    </div>
  );

  function isDataChanged() {
    if (mode === "create") {
      if (name || name != "") return true;
    }
    if (mode === "edit") {
      if (name !== origObject.name) return true;
    }
    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"sm"}
          fullWidth={true}
          style={{ height: 500 }}
          open={true}
          onCloseWindow={onCloseWindow}
          hideSave={
            (!props.context.privileges.ledger_edit &&
              !props.context.privileges.ledger_opening_balance_update &&
              props.context.privileges.ledger_delete) ||
              mode === "view"
              ? mode === "create"
                ? false
                : true
              : false
          }
          onSave={onSave}
          onDelete={props.context.privileges.ledger_delete ? onDelete : false}
          // onDelete={onDelete}
          mode={
            props.context.privileges.ledger_delete && mode == "view"
              ? "edit"
              : mode
          }
          isDataChanged={isDataChanged}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}
    </div>
  );
}
